import React, { ReactNode } from "react";
import { Box, CircularProgress, Paper, useTheme } from "@mui/material";

type ProfileContainerProps = {
  id: string;
  loading?: boolean;
  title?: string;
  children?: ReactNode;
};

const ProfileContainer: React.FC<ProfileContainerProps> = ({
  id,
  loading,
  title,
  ...props
}) => {
  const theme = useTheme();
  const renderTitle = () => {
    if (!title) {
      return null;
    }
    return (
      <Box
        id={id}
        sx={(theme) => ({
          width: "fit-content",
          position: "absolute",
          height: "26px",
          lineHeight: "26px",
          top: "-13px",
          left: "0",
          fontSize: "0.9em",
          fontStyle: "italic",
          backgroundColor:
            theme.palette.mode === "dark" ? "#1e1e1e" : "#eff2f6",
          border: "0",
          borderRadius: "3px",
          boxShadow:
            theme.palette.mode === "dark"
              ? "inset 0 0 0 1px #555"
              : "inset 0 0 0 1px #cfd8e3",
          padding: "0px 15px",
          color: theme.palette.mode === "dark" ? "#e0e0e0" : "#2e3d4f",
        })}
      >
        {title}
      </Box>
    );
  };

  return (
    <Box
      sx={(theme) => ({
        position: "relative",
        borderRadius: "3px",
        padding: "3em 3em 2em 3em",
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.background.default
            : "#fff",
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgba(0, 0, 0, 0.5) 0px 2px 4px 1px"
            : "rgba(0, 0, 0, 0.1) 0px 2px 2px 1px",
      })}
    >
      {renderTitle()}
      {loading ? (
        <Box
          sx={{
            minHeight: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        props.children
      )}
    </Box>
  );
};

export default ProfileContainer;
